import Phaser from "phaser";

export const TEX_BLOB = "prim-blob";
export const TEX_SHADOW = "prim-shadow";
export const TEX_PIXEL = "prim-pixel";

export function ensurePrimitiveTextures(scene: Phaser.Scene): void {
  if (!scene.textures.exists(TEX_PIXEL)) {
    const graphics = scene.make.graphics({}, false);
    graphics.fillStyle(0xffffff, 1);
    graphics.fillRect(0, 0, 1, 1);
    graphics.generateTexture(TEX_PIXEL, 1, 1);
    graphics.destroy();
  }

  if (!scene.textures.exists(TEX_BLOB)) {
    const graphics = scene.make.graphics({}, false);
    graphics.fillStyle(0xffffff, 1);
    graphics.fillEllipse(32, 16, 64, 32, 16);
    graphics.generateTexture(TEX_BLOB, 64, 32);
    graphics.destroy();
  }

  if (!scene.textures.exists(TEX_SHADOW)) {
    const texture = scene.textures.createCanvas(TEX_SHADOW, 64, 32);
    const ctx = texture?.getContext();
    if (texture && ctx) {
      const gradient = ctx.createRadialGradient(32, 16, 2, 32, 16, 28);
      gradient.addColorStop(0, "rgba(20, 14, 8, 0.72)");
      gradient.addColorStop(1, "rgba(20, 14, 8, 0)");
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, 64, 32);
      texture.refresh();
    } else if (!scene.textures.exists(TEX_SHADOW)) {
      const graphics = scene.make.graphics({}, false);
      graphics.fillStyle(0x1c140c, 1);
      graphics.fillEllipse(32, 16, 64, 32, 16);
      graphics.generateTexture(TEX_SHADOW, 64, 32);
      graphics.destroy();
    }
  }
}

export function addBlob(
  scene: Phaser.Scene,
  x: number,
  y: number,
  width: number,
  height: number,
  color: number,
  alpha = 1,
): Phaser.GameObjects.Image {
  ensurePrimitiveTextures(scene);
  const image = scene.add.image(x, y, TEX_BLOB);
  image.setDisplaySize(Math.max(1, width), Math.max(1, height));
  image.setTint(color);
  image.setAlpha(alpha);
  return image;
}

export function addShadowBlob(
  scene: Phaser.Scene,
  x: number,
  y: number,
  width: number,
  height: number,
  alpha = 0.3,
): Phaser.GameObjects.Image {
  ensurePrimitiveTextures(scene);
  const image = scene.add.image(x, y, TEX_SHADOW);
  image.setDisplaySize(Math.max(1, width), Math.max(1, height));
  image.setAlpha(alpha);
  return image;
}

export function sizeBlob(image: Phaser.GameObjects.Image, width: number, height: number): void {
  image.setDisplaySize(Math.max(1, width), Math.max(1, height));
}
